<template>
  <div class="filter-options">
    <h1 class="small-title show-mobile">Filter</h1>
    <div class="transaction-filter">
      <el-checkbox v-model="transactionFilter.purchases">Station transactions</el-checkbox>
      <el-checkbox v-model="transactionFilter.deposits">Saldo refill</el-checkbox>
      <el-button type="primary" icon="el-icon-date" class="date-filter-button" @click="$emit('selectDate')" plain>Date filter</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionsFilterOptions',
  props: {
    transactionCount: {
      type: Number,
      required: true
    },
    transactionFilter: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .filter-options {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: uppercase;

    p {
      font-size: 14px;
      color: #C0C4CC;
      margin: 0;

      span {
        color: $main;
      }
    }

    @include breakpoint (xs) {
      padding: 20px;
      height: 200px;
      width: 100%;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      button {
        width: 100%;
        margin-left: 0px;
        margin-top: 20px;
      }
    }
  }

  .date-filter-button {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/TransactionsFilterOptions.vue